export const purchaseBlockedModalState = {
  limit: 'limit',
  unable: 'unable'
}
